import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Frame from "./Frame";

import App from "./App";
import { Settings } from "./App";
import ViewOrders from "./routes/ViewOrders";
import OrderDetails from "./routes/OrderDetails";
import ManageProducts from './routes/ManageProducts';
import ViewUsers from './routes/Users';
import ProductDetails from './routes/ProductDetails';
import NewProduct from './routes/NewProduct';
import GiftDetails from './routes/GiftDetails';
import Links from './routes/Links';
import PuppyGenerator from './routes/PuppyGenerator';
import CachingSystem from './routes/CachingSystem';

import BookBuilder from './routes/BookBuilder';
import BookBuilderPage from './routes/BookBuilderPage';

import awsConfig from './amplify_outputs'
import config from './config';
import { Amplify } from 'aws-amplify';

const host = config.backendUrl;
Amplify.configure(awsConfig);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Frame />,
    children: [
      {
        path: "/",
        element: <App />,
      },
      {
        path: "/orders",
        element: <ViewOrders />,
      },
      {
        path: "/orders/gift/:orderId",
        element: <GiftDetails />,
      },
      {
        path: "/orders/:orderId",
        element: <OrderDetails />,
      },
      {
        path: "/products",
        element: <ManageProducts />,
      },
      {
        path: "/products/new",
        element: <NewProduct />,
      },
      {
        path: "/products/:productId",
        element: <ProductDetails />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/users",
        element: <ViewUsers />,
      },
      {
        path: "/book-builder/:productId",
        element: <BookBuilder />,
      },
      {
        path: "/book-builder/:productId/page/:page",
        element: <BookBuilderPage />,
      },
      {
        path: "/links",
        element: <Links />,
      },
      {
        path: "/puppy-generator",
        element: <PuppyGenerator />,
      },
      {
        path: "/caching-system",
        element: <CachingSystem />,
      }
    ],
  },
  {
    path: "/test",
    element: <Frame testMode={true} />,
    children: [
      {
        path: "/test",
        element: <App testMode={true} />,
      },
      {
        path: "/test/orders",
        element: <ViewOrders testMode={true} />,
      },
      {
        path: "/test/orders/:orderId",
        element: <OrderDetails testMode={true} />,
      },
      {
        path: "/test/orders/gift/:orderId",
        element: <GiftDetails testMode={true} />,
      },
      {
        path: "/test/products",
        element: <ManageProducts testMode={true} />,
      },
      {
        path: "/test/products/new",
        element: <NewProduct testMode={true} />,
      },
      {
        path: "/test/products/:productId",
        element: <ProductDetails testMode={true} />,
      },
      {
        path: "/test/settings",
        element: <Settings testMode={true} />,
      },
      {
        path: "/test/users",
        element: <ViewUsers testMode={true} />,
      },
      {
        path: "/test/book-builder/:productId",
        element: <BookBuilder testMode={true} />,
      },
      {
        path: "/test/book-builder/:productId/page/:page",
        element: <BookBuilderPage testMode={true} />,
      },
      {
        path: "/test/links",
        element: <Links testMode={true} />,
      },
      {
        path: "/test/puppy-generator",
        element: <PuppyGenerator testMode={true} />,
      },
      {
        path: "/test/caching-system",
        element: <CachingSystem testMode={true} />,
      }
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals